import { LanguageService } from "../services/language-service.js";
import { InitializeBookingForm } from "../booking.js";
import { SetupMapViewLinks } from "./mapLinkModule.js";
import { RegisterHelpers as RegisterHandlbarsHelpers } from "../helpers/handlebars-helpers.js";
import { ModalComponent } from "../components/modal/modal.component.js";
import { ApiService } from "../services/api-service.js";
import * as Log from "../helpers/browserConsole.js";
import { Toast } from "toaster-js";
import * as RX from "rxjs";
import { QueryService } from "../services/query-service.js";
import { SetupCopyToClipboardButtons } from "./copyToClipboardButtonModule.js";
import { SimpleFavorites } from "../services/favorites/favorites-simple.js";
import { array, option } from "fp-ts";
import { UGFavorites } from "../services/favorites/favorites-ug.js";
import { pipe } from "fp-ts/lib/function.js";
import { Language } from "../models/language.js";
import { Option } from "fp-ts/lib/Option.js";
import { App } from "./app.js";
import { initializeRootSearchView, ServiceSet } from "./searchviewModule.js";
import { getSiteConfig } from "./getSiteConfig.js";
import { initializeTooltips } from "../helpers/tippy-helpers.js";
import { getAttributeValue } from "../helpers/getAttribute.js";
import { initializeSwiper } from "../helpers/swiper-helpers.js";
import { initializePhotoSwipe } from "../helpers/photo-swipe-lightbox.js";

export type SiteConfig = {
  type: "hosted" | "app-loader";
  clientSpecificClass: string;
  language: Language;
  apiBaseURL: string;
  pageId: Option<number>;
};

function getServices(config: SiteConfig): ServiceSet {
  const languageService = new LanguageService(config.language);
  const favoritesService =
    config.type == "app-loader"
      ? new UGFavorites(languageService)
      : new SimpleFavorites(languageService);
  return {
    languageService: languageService,
    apiService: new ApiService(config.apiBaseURL, config.language),
    queryService: new QueryService(),
    favoritesService: favoritesService,
  };
}

export function Main() {
  RX.config.onUnhandledError = (e) => {
    Log.error("Fatal", e);
    new Toast(e, Toast.TYPE_ERROR, 5000);
  };

  const config: SiteConfig = getSiteConfig();
  const services: ServiceSet = getServices(config);
  App.setApiService(services.apiService);

  // Common plugin setup
  RegisterHandlbarsHelpers();
  initializeTooltips();
  initializeSwiper();
  initializePhotoSwipe();

  // // Listen for clicks on buttons which should show a search module in a modal
  // Brugt i tidlgiere løsning til at åbne en modal med oversigt i en modal for eks. en udstiller
  // Eks. en udstillers produkter
  // SetupSearchModuleModalButtons(
  //   services.languageService,
  //   services.apiService,
  //   services.favoritesService
  // );

  // Listen for clicks on buttons which should show a map in a modal
  SetupMapViewLinks(
    config.language,
    services.apiService,
    config.clientSpecificClass
  );

  // Setup copy-value buttons
  SetupCopyToClipboardButtons(services.languageService);

  ModalComponent.configure(services.languageService);

  if (config.type == "hosted" && typeof udstillerguide != "undefined") {
    setupStuffOnHostedSites(udstillerguide, services);
  }

  // Initialize new app elements
  SetupSearchViews(services);
}

function setupStuffOnHostedSites(
  hostedConfig: HostedSiteConfig,
  services: ServiceSet
) {
  // Setup booking form
  if (hostedConfig.pageType === "udstiller") {
    InitializeBookingForm(
      hostedConfig.pageId.toString(),
      services.languageService
    );
  }
}

function SetupSearchViews(services: ServiceSet) {
  let searchViewCounter = 0;
  pipe(
    document.querySelectorAll<HTMLElement>(".ug-app"),
    Array.from,
    array.map((appElm: HTMLElement) => {
      const maybeSearchViewId = getAttributeValue(appElm, "data-ug-id");
      if (option.isNone(maybeSearchViewId)) {
        return;
      }
      const searchViewId = maybeSearchViewId.value;

      // Tilføj et unikt ID til appElm
      const uniqueId = `ug-searchview-${searchViewId}-${searchViewCounter}`;
      appElm.id = uniqueId;

      // Inkrementer tælleren for næste element
      searchViewCounter++;

      initializeRootSearchView(services, searchViewId, appElm);
    })
  );
}
